import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions';
import 'firebase/storage';

const firebaseConfig = require('./firebase-config.json');
if (firebaseConfig.status === 'success') {
    firebase.initializeApp(firebaseConfig.result);
}

const auth = firebase.auth();
const database = firebase.database();
const functions = firebase.functions();
const storage = firebase.storage();
const PROJECT_ID = firebaseConfig.result.projectId;
const isProduction = PROJECT_ID === 'caazam-26c36';
export { auth, database, functions, storage, PROJECT_ID, isProduction };


// WEBPACK FOOTER //
// ./src/firebaseApp.js